export default "__VITE_ASSET__BWA3r$1N__"